export const columnDescriptions = {
    ordcom: "Ordem Compra", 
    codope: "Comprador",
    nomope: "Nome Comprador",
    celcorp: "Telefone Comprador",
    codpro: "Código Produto", 
    profor: "Código Produto (Fornecedor)",
    nompro: "Nome Produto", 
    codfor: "Fornecedor",
    nomcli: "Nome Fornecedor",
    cgccli: "CPF/CNPJ",
    despro: "Descr. Produto", 
    tippro: "Tipo Produto",
    qtdpro: "Quantidade",
    univen: "Unidade",
    valpro: "Valor (R$)",
    forpag: "Forma Pagamento",
    desforpag: "Descr. Forma Pagamento",
    tippag: "Tipo Pagamento",
    destippag: "Descr. Pagamento",
    prapag: "Prazo Pagamento",
    tipfre: "Tipo Frete",
    desfre: "Descr. Frete",
    praent: "Prazo entrega",
    status: "Status Aprovação",
    status_res: "Status Resposta",
    datpro: "Data Proposta"
}